// extracted by mini-css-extract-plugin
module.exports = {"mobileScreen":"mobileScreen__2aaP6gMIrBVQb","img":"img__tuxXLHjhHZzmY","title":"title__KgngnGJxgjCE-","description":"description__egRQ+UkInvhho","button":"button__PAdqqxWbqiW6Y"};